import { AUTH_ERROR_MESSAGES_MAP, DEFAULT_AUTH_ERROR_MESSAGE } from '../constants';
import { AuthActionType, AuthErrorCode } from '../enums';

export class AuthError {
  readonly code: AuthErrorCode;
  readonly message: string;

  constructor(
    readonly actionType: AuthActionType,
    code?: AuthErrorCode,
  ) {
    this.code = code || AuthErrorCode.Unknown;
    const map: Map<AuthActionType, string> = AUTH_ERROR_MESSAGES_MAP.get(code);
    this.message = map.get(actionType) || DEFAULT_AUTH_ERROR_MESSAGE;
  }
}
